export default __webpack_public_path__ + "static/media/Mask.6cbd1244.png";